import AnnouncementModal from '@/components/Modal/AnnouncementModal'
import FillPONumberModal from '@/components/Modal/FillPONumberModal/FillPONumberModal'
import MessageModal from '@/components/Modal/MessageModal'
import ECCNDetailModal from '@/features/offers/components/Modal/ECCNDetailModal'
import ManualUploadVendorQuotationModal from '@/features/offers/components/Modal/ManualUploadVendorQuotationModal'
import {
  DraftPRSubmissionModal,
  OfferCostBudgetQuotationDetailModal,
  OfferVendorDetailModal,
  RFQModal,
  WorkInstructionHistoryModal,
} from '@/features/offers/offer-detail/modals'
import InvitationDetailModal from '@/features/offers/components/Modal/InvitationDetailModal/InvitationDetailModal'
import AddInvitationModal from '@/features/offers/components/Modal/InvitationDetailModal/AddInvitationModal'
import { MODAL_TYPES } from '@/utils/constants/modalTypes'
import { useSelector } from 'react-redux'

const ModalRoot = () => {
  const { modalStack } = useSelector((state) => state.modal)

  const renderModal = ({ modalType, modalProps }) => {
    switch (modalType) {
      case MODAL_TYPES.ECCN_DETAIL:
        return <ECCNDetailModal {...modalProps} />
      case MODAL_TYPES.ANNOUNCEMENT:
        return <AnnouncementModal {...modalProps} />
      case MODAL_TYPES.MESSAGE:
        return <MessageModal {...modalProps} />
      case MODAL_TYPES.RFQ:
        return <RFQModal {...modalProps} />
      case MODAL_TYPES.OFFER_VENDOR_DETAIL:
        return <OfferVendorDetailModal {...modalProps} />
      case MODAL_TYPES.OFFER_MANUAL_UPLOAD_VENDOR_QUOTATION:
        return <ManualUploadVendorQuotationModal {...modalProps} />
      case MODAL_TYPES.DRAFT_PR_SUBMISSION:
        return <DraftPRSubmissionModal {...modalProps} />
      case MODAL_TYPES.OFFER_COST_BUDGET_QUOTATION_DETAIL:
        return <OfferCostBudgetQuotationDetailModal {...modalProps} />
      case MODAL_TYPES.INVITATION_DETAIL:
        return <InvitationDetailModal {...modalProps} />
      case MODAL_TYPES.ADD_INVITATION:
        return <AddInvitationModal {...modalProps} />
      case MODAL_TYPES.WORK_INSTRUCTION_HISTORY:
        return <WorkInstructionHistoryModal {...modalProps} />
      default:
        return null
    }
  }

  return (
    <>
      {modalStack.map((modalItem, index) => (
        // Use index as key since stack follows LIFO - items always append/pop from end
        <div key={`modal-${index}`}>{renderModal(modalItem)}</div>
      ))}
      <FillPONumberModal />
    </>
  )
}

export default ModalRoot
